module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/merit-cafe-70d690bf0e61c57e255ef1f05fa748ad.png";